<button *ngIf="!activitySidebar" pButton type="button" icon="pi pi-arrow-left" (click)="openSidebar()" class="activityBtn p-button-lg"></button>
<button *ngIf="activitySidebar" pButton type="button" icon="pi pi-arrow-right" (click)="activitySidebar = false" class="activityBtn2 p-button-lg"></button>

<p-sidebar *ngIf="activitySidebar" #activity (onHide)="activity.destroyModal()" [(visible)]="activitySidebar" position="right" [baseZIndex]="999" class="activityBar" [dismissible]="false" [blockScroll]="true" [modal]="false">

    <div class="p-d-flex p-jc-between p-mt-2" [ngClass]="{'p-mb-3': !showCalendar}">
        <p-button icon="pi pi-calendar" (click)="showCalendar = !showCalendar"></p-button>
        <div>
            <span class="btnBars overdueIcon p-mr-2" (click)="showOverdue = !showOverdue; debugger;" [class.active]="showOverdue">
                <i class="fa fa-bell-o fa-lg" aria-hidden="true"></i>
                <span class="alertBadge">{{totalNotifications}}</span>
            </span>
            <p-button icon="pi pi-filter" (click)="taskItems.toggle($event)"></p-button>
            <p-button *ngIf="!isViewMode" icon="pi pi-plus" class="p-ml-2" (click)="barActivityItems.toggle($event)"></p-button>
        </div>
    </div>

    <div *ngIf="showCalendar" class="p-mt-2 p-mb-3">
        <p-calendar [(ngModel)]="eventDate" [inline]="true" showButtonBar="true" inputId="buttonbar" [clearButtonStyleClass]="'hideClearButton'" (onSelect)="getDate(eventDate)"></p-calendar>
    </div>

    <p-overlayPanel #taskItems styleClass="activityItems">
        <ng-template pTemplate>
            <ul>
                <li (click)="taskItems.hide($event); fetchFilteredActivities(filters.ALL_ACTIVITY);" [class.active]="filterValue === filters.ALL_ACTIVITY">
                    <span><i class="pi pi-list p-mr-2"></i>All Activities</span>
                </li>
                <li (click)="taskItems.hide($event); fetchFilteredActivities(filters.EVENTS);" [class.active]="filterValue === filters.EVENTS">
                    <span><i class="pi pi-calendar-plus p-mr-2"></i>Events</span>
                </li>
                <li (click)="taskItems.hide($event); fetchFilteredActivities(filters.TASKS);" [class.active]="filterValue === filters.TASKS">
                    <span><i class="pi pi-calendar-plus p-mr-2"></i>Tasks</span>
                </li>
                <li (click)="taskItems.hide($event); fetchFilteredActivities(filters.OPEN_TASKS);" class="innerList" [class.active]="filterValue === filters.OPEN_TASKS">
                    <span>Open Tasks</span>
                </li>
                <li (click)="taskItems.hide($event); fetchFilteredActivities(filters.COMPLETED_TASKS);" class="innerList" [class.active]="filterValue === filters.COMPLETED_TASKS">
                    <span>Completed Tasks</span>
                </li>
            </ul>
        </ng-template>
    </p-overlayPanel>

    <p-overlayPanel #barActivityItems styleClass="activityItems">
        <ng-template pTemplate>
            <ul>
                <li (click)="openTaskAddDialog(); barActivityItems.hide($event)">
                    <span><i class="pi pi-list p-mr-2"></i>Tasks</span>
                </li>
                <li (click)="openCreateEventDialog(); barActivityItems.hide($event);" *ngIf="usersInCalendar.length > 0">
                    <span><i class="pi pi-calendar-plus p-mr-2"></i>Events</span>
                </li>
                <li (click)="configureEvents(); barActivityItems.hide($event);" *ngIf="usersInCalendar.length == 0">
                    <span><i class="pi pi-calendar-plus p-mr-2"></i>Configure Events</span>
                </li>
            </ul>
        </ng-template>
    </p-overlayPanel>

    <ng-container *ngIf="!showOverdue">
        <div class="activity-barCard" *ngIf="showNoEventTask">
            <div class="p-p-2">
                No Event/Task.
            </div>
        </div>
        <ng-container *ngFor="let d of activities; let i = index;">
            <div class="activity-barCard" [ngClass]="{'p-p-0': activities && d.dataList.length == 0 && !checkSameDate(d.date,today)}">
                <h6 class="p-my-4">
                    <ng-container *ngIf="checkSameDate(d.date,today) && d.dataList.length > 0">
                        Today - {{d.date | date:'EE, MMMM d, yyyy'}}
                    </ng-container>
                    <ng-container *ngIf="checkSameDate(d.date,tomorrow) && d.dataList.length > 0">
                        Tomorrow - {{d.date | date:'EE, MMMM d, yyyy'}}
                    </ng-container>
                    <ng-container *ngIf="!checkSameDate(d.date,today) && !checkSameDate(d.date,tomorrow) && d.dataList.length > 0">
                        {{d.date | date:'EE, MMMM d, yyyy'}}
                    </ng-container>
                </h6>
                <div class="p-p-2" *ngIf="checkSameDate(d.date,today) && d.dataList.length == 0">
                    No Event/Task for today.
                </div>
                <ng-container *ngFor="let s of d.dataList; let i = index;">
                    <div class="p-d-flex cursor-pointer p-my-3" style="padding-bottom: 0.5rem" [style.border-bottom]="i+1 < d.dataList.length ? '1px solid #eaeaea' : ''" (click)="openActivityDetail(s)">
                        <div class="activity-icon bg-event p-shadow-3" style="width: 1.8rem; height: 1.8rem; padding: 0.4rem" *ngIf="s.activityName == 'CalendarEvent'">
                            <span class="pi pi-calendar"></span>
                        </div>
                        <div class="activity-icon bg-task p-shadow-3" style="width: 1.8rem; height: 1.8rem; padding: 0.4rem" *ngIf="s.activityName == 'Task'">
                            <span class="pi pi-list"></span>
                        </div>
                        <div class="activity-content p-ml-2 w-100">
                            <div class="p-mb-1">
                                <div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: 700;">
                                    <div>
                                        {{ s.activityName === 'Task' ? 'Task' : 'Event' }} ID: {{ s?.activityId }}
                                    </div>
                                    <ng-container *ngIf="checkTaskStatus(s) == null">
                                        <div>
                                            <span style="float: right;">
                                                {{s.startDateTime | localDate}}
                                            </span>
                                        </div>
                                    </ng-container>
                                </div>
                                <span pTooltip="{{s.title}}" tooltipPosition="top" style="font-weight: 600;">
                                    {{ s.title?.length < 35 ? s.title : s.title.substring(0,45) + "..." }} </span>
                                <ng-container *ngIf="s.activityName == 'Task'">
                                    <!-- <ng-container *ngIf="checkTaskStatus(s) == 'overDueTask'">
                                                <span style="float: right;" class="overDueTask">
                                                    {{s.endDateTime | localDate:'ha z'}}
                                                </span>
                                            </ng-container> -->
                                    <ng-container *ngIf="checkTaskStatus(s) == 'completeTask'">
                                        <span style="float: right;" class="p-mt-2">
                                                    <i class="pi pi-check-circle" style="color: #9fd037"></i>
                                                </span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="s.activityName == 'CalendarEvent' && checkForOverdue(s.endDateTime)">
                                    <div style="float: right;">
                                        <span class="p-mt-2">
                                                    <i class="pi pi-check-circle" style="color: #9fd037"></i>
                                                </span>
                                    </div>
                                </ng-container>
                            </div>

                            <p *ngIf="s.activityName == 'Task'" pTooltip="{{s.description | removeHtmlTags}}" tooltipPosition="left" style="word-break: break-all;" class="p-mb-0">
                                {{ (s.description | removeHtmlTags).length < 118 ? (s.description | removeHtmlTags) : (s.description | removeHtmlTags).substring(0, 118) + '...' }}</p>
                                    <p *ngIf="s.activityName == 'CalendarEvent'" pTooltip="{{s.description}}" tooltipPosition="left" class="p-mb-0" style="word-break: break-all;">{{ (s.description | removeHtmlTags).length < 118 ? (s.description | removeHtmlTags) : (s.description | removeHtmlTags).substring(0, 118) + '...' }}
                                    </p>
                                    <p class="p-mb-0" *ngIf="s.categoryName">
                                        {{ s.categoryName }}
                                    </p>
                                    <p class="p-mb-0">
                                        End date: {{ s.endDateTime | localDate }}
                                    </p>
                                    <p tooltipPosition="top" class="p-mb-0 p-text-right">
                                        by {{s.createdByName}}
                                    </p>
                        </div>
                    </div>
                </ng-container>

                <div *ngIf="(!d.dataList || !d.dataList.length) && !loadingActivities" class="no-activities">
                    No activities found.
                </div>
            </div>
            <p-divider *ngIf="d.dataList.length != 0 || checkSameDate(d.date,today)"></p-divider>
        </ng-container>

        <div *ngIf="(!activities || !activities?.length) && !loadingActivities" class="no-activities">
            No activities found.
        </div>
    </ng-container>

    <ng-container *ngIf="showOverdue">
        <div class="activity-barCard">
            <ng-container *ngFor="let s of notifications; let i = index;">
                <h6 class="p-my-1" *ngIf="!checkSameDate(s?.date,activityOverDue[i-1]?.date)">
                    {{s.date | date:'EE, MMMM d, yyyy'}}
                </h6>
                <div class="p-d-flex cursor-pointer p-my-3" style="padding-bottom: 0.5rem" [style.border-bottom]="i+1 < notifications.length ? '1px solid #eaeaea' : ''" (click)="openActivityDetail(s)">
                    <div class="activity-icon bg-event p-shadow-3" style="width: 1.8rem; height: 1.8rem; padding: 0.4rem" *ngIf="s.activityName == 'CalendarEvent'">
                        <span class="pi pi-calendar"></span>
                    </div>
                    <div class="activity-icon bg-task p-shadow-3" style="width: 1.8rem; height: 1.8rem; padding: 0.4rem" *ngIf="s.activityName == 'Task'">
                        <span class="pi pi-list"></span>
                    </div>
                    <div class="activity-content p-ml-2 w-100">
                        <div class="p-mb-1">
                            <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-weight: 700;">
                                <div>
                                    ID: {{ s.id }}
                                </div>
                                <ng-container *ngIf="checkTaskStatus(s) == null">
                                    <div>
                                        <span style="float: right;">
                                            {{s.startDateTime | localDate}}
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                            <span pTooltip="{{s.title}}" tooltipPosition="top" style="margin-bottom: 8px;">
                                {{ s.title.length < 35 ? s.title : s.title.substring(0,45) + "..." }}
                            </span>
                            <!-- <span style="float: right;" class="overDueTask">
                                {{s.startDateTime | localDate:'ha z'}} - {{s.endDateTime | localDate:'ha z'}}
                            </span> -->
                        </div>
                        <p *ngIf="s.activityName == 'Task'" pTooltip="{{s.description}}" tooltipPosition="top" style="word-break: break-all;" class="p-mb-0">
                            {{ s.description.length
                            < 118 ? s.description : s.description.substring(0,118) + "..." }} </p>
                                <p *ngIf="s.activityName == 'CalendarEvent'" pTooltip="{{s.description}}" tooltipPosition="top" class="p-mb-0" style="word-break: break-all;" [innerHTML]="s.description.length < 118 ? s.description : s.description.substring(0,118) + '...'">
                                </p>
                                <p class="p-mb-0" *ngIf="s.categoryName">
                                    {{ s.categoryName }}
                                </p>
                                <p class="p-mb-0">
                                    End date: {{ s.endDateTime | localDate }}
                                </p>
                                <p tooltipPosition="top" class="p-mb-0 p-text-right">
                                    by {{s.createdByName}}
                                </p>
                    </div>
                </div>
            </ng-container>

            <div *ngIf="(!notifications || !notifications.length) && !loadingNotifications" class="no-activities">
                No notifications found.
            </div>
        </div>
    </ng-container>

    <div class="p-text-center p-my-4" *ngIf="showLoadMoreBtn">
        <button pButton type="button" (click)="loadMore()" class="p-button-raised p-button-rounded">
            Load More {{ showOverdue ? 'Notifications' : 'Activities' }}
        </button>
    </div>
</p-sidebar>

<!-- Create a new task -->
<!-- <app-create-task *ngIf="displayAddTask" [headerTitle]="'Add New Task'" [display]="displayAddTask" [objectId]="objectId" [objectTypeId]="objectTypeId" [selectedObject]="selectedObject" [selectedChannel]="selectedChannel" (onCreateComplete)="createComplete($event)"
    (cancelClicked)="cancelTaskAdd()">
</app-create-task> -->

<app-shared-create-task *ngIf="displayAddTask" [isAddTask]="isAddTask" [headerTitle]="'Add New Task'" [displayAddEditDialog]="displayAddTask" [moduleId]="objectId"  (onCreateComplete)="createComplete($event)"
(cancelClicked)="cancelTaskAdd()">
</app-shared-create-task>

<!-- To show event details on click and toggle update -->
<app-lion-shared-events
    *ngIf="displayEventDetails && eventMode=='edit'"
    [displayAddEvent]="displayEventDetails"
    [mode]="eventMode"
    [objectId]="editObjectId"
    [isUserCalendar]="isUserCalendar"
    [selectedObject]="selectedObject"
    [objectTypeId]="editObjectTypeId"
    [event]="event"
    [isViewMode]="isViewMode"
    [usersInCalendar]="usersInCalendar"
    [selectedChannel]="selectedChannel"
    (completeEvent)="completeEditEvent()"
    [eventFromModule]="false"
    (cancelEvent)="cancelEditEvent()">
</app-lion-shared-events>

<!-- Create a new event -->
<app-lion-shared-events
    *ngIf="displayEventDetails && eventMode=='add'"
    [displayAddEvent]="displayEventDetails"
    [mode]="eventMode"
    [objectId]="objectId"
    [isUserCalendar]="isUserCalendar"
    [usersInCalendar]="usersInCalendar"
    [selectedObject]="selectedObject"
    [objectTypeId]="objectTypeId"
    [event]="event"
    [eventFromModule]="false"
    [selectedChannel]="selectedChannel"
    (completeEvent)="completeEditEvent()"
    (cancelEvent)="cancelEditEvent()">
</app-lion-shared-events>

<app-config-external-client
    [displayConfigExternalClient]="displayConfigExternalClient"
    [vendorCategoryId]="calendarCategoryId"
    [initialCalerdarListCount]="initialCalerdarListCount"
    (modalCloseHandler)="closeConfigModal()"
    (onCalendarConfigCompleted)="onCalendarConfigCompleted()">
</app-config-external-client>

<!-- <app-lion-add-update-view-event *ngIf="displayEventDetail" [currentDisplay]="displayEventDetail" [eventTemp]="eventTemp"
    [allUsersList]="allUsersList" (closeDialog)="closeDialog()">
</app-lion-add-update-view-event> -->
